import React, { useEffect, useState } from 'react';

import api from 'services/api';

import { useDashboard } from 'containers/dashboard';

import Button from 'components/Button';
import Spinner from 'components/Spinner';
import GridFlex from 'components/GridFlex';
import { SmallSelect, Checkbox } from 'components/Fields';

import { useDebounce } from 'hooks/useDebounce';
import { WrapperSelect, WrapperButtonSelect, WrappCheckbox } from '../styles';

const filterType = 'seasons';

interface IList {
  id: number;
  description: string;
  year: number;
}

const SeasonFilter: React.FC = () => {
  const [search, setSearch] = useState('');
  const [isInit, setIsInit] = useState(true);
  const [list, setList] = useState<IList[]>([]);
  const [loading, setLoading] = useState(false);

  const {
    data: {
      filters: {
        multiples: { seasons },
      },
    },
    actions: { addToFilter, hasOnFilter, removeFilter, resetFilter },
  } = useDashboard();

  const getSeasons = async () => {
    if (isInit) {
      setIsInit(false);
      return;
    }

    setLoading(true);

    const newList: IList[] = await api.get(
      `/seasons?isActive=1&description=${search}`,
    );
    setList(newList);

    setLoading(false);
  };

  const autoSave = useDebounce(search);

  const saveChange = async () => {
    getSeasons();
  };

  useEffect(() => {
    saveChange();
  }, [autoSave]);

  return (
    <WrapperSelect>
      <SmallSelect
        withInputSearch
        dataTest="select-test"
        inputSearchPlaceholder="Search"
        inputSearchOnChange={setSearch}
        inputSearchvalue={search}
        placeholder="Season"
        numberSelected={Number(seasons?.length)}
        maxHeight="270px"
        onOpen={() => !list.length && getSeasons()}
        auxiliaryButton={
          <WrapperButtonSelect>
            <Button
              scheme="nobg"
              data-testid="reset-filter"
              onClick={() => {
                setSearch('');
                resetFilter(filterType);
              }}
              padding="9px 20px"
            >
              Reset filters
            </Button>
          </WrapperButtonSelect>
        }
      >
        <>
          {loading ? (
            <GridFlex alignItems="center" justifyContent="center">
              <Spinner />
            </GridFlex>
          ) : (
            <WrappCheckbox>
              {list.map((item: any) => (
                <Checkbox
                  key={`${filterType}-${item.description}-${item.id}`}
                  isChecked={hasOnFilter(filterType, item)}
                  label={`${item.description} ${
                    item.year ? `${item.year}` : ''
                  }`}
                  name={item.description}
                  onClick={() =>
                    !hasOnFilter(filterType, item)
                      ? addToFilter(filterType, item)
                      : removeFilter(filterType, item)
                  }
                  width="11px"
                  widthIcon="5px"
                  marginRightIcon="7px"
                  textFontSize={11}
                />
              ))}
            </WrappCheckbox>
          )}
        </>
      </SmallSelect>
    </WrapperSelect>
  );
};

export default SeasonFilter;
